<ws-modal-wrapper
    [headerLabel]="headerLabel"
    acceptLabel="Confirm"
    cancelLabel="Cancel"
    acceptClass="btn-primary"
    cancelClass="btn-outline-primary"
    [disableSave]="disableSave"
    (save)="save()"
    (cancel)="cancel()"
>
    <div class="mb-3">
        <label for="approval-comment" class="form-label">Comment {{ isRejection ? '(required)' : '(optional)' }}:</label>
        <textarea
            id="approval-comment"
            class="form-control"
            [class.is-invalid]="commentTouched && isCommentMissing"
            [(ngModel)]="comment"
            (blur)="commentTouched = true"
            rows="4"
            placeholder="Enter an approval comment..."
        ></textarea>
        <div class="invalid-feedback" *ngIf="commentTouched && isCommentMissing">
            A comment is required when rejecting a payment.
        </div>
    </div>
</ws-modal-wrapper>
